export * from './FunctionButtons.js';
export var Enabled;
(function (Enabled) {
    Enabled["OFF"] = "OFF";
    Enabled["ON"] = "ON";
})(Enabled || (Enabled = {}));
export var ParserStatus;
(function (ParserStatus) {
    ParserStatus["SUCCESS"] = "success";
    ParserStatus["FAILURE"] = "failure";
})(ParserStatus || (ParserStatus = {}));
export var FunctionName;
(function (FunctionName) {
    FunctionName["EEPROMS_ERASE"] = "eraseParser";
    FunctionName["EEPROMS_STORE"] = "storeParser";
    FunctionName["LOCO"] = "locoParser";
    FunctionName["POWER"] = "powerParser";
    FunctionName["ROSTER_ITEM"] = "rosterItemParser";
    FunctionName["THROTTLE"] = "throttleParser";
    FunctionName["DECODER_ADDRESS"] = "decoderAddress";
    FunctionName["TURNOUT"] = "turnoutParser";
    FunctionName["TURNOUT_DCC"] = "turnoutDCCParser";
})(FunctionName || (FunctionName = {}));
